<template>  
	<div class="row">
		<div class="documentation">
			<div class="documentation-container">
				
				<div id="response_errors" class="response_errors_container" style="display:none"></div>
				
				<div>
					
					<nav aria-label="breadcrumb" class="d-none d-xl-block">
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="/docs">Документы</a></li>
							<li class="breadcrumb-item"><a href="/docs-edit">Список документов</a></li>
							<li v-if="type == 'create'" class="breadcrumb-item active" aria-current="page">Добавить новый документ</li>
							<li v-if="type == 'update'" class="breadcrumb-item active" aria-current="page">Редактировать документ</li>
						</ol>
					</nav>
					<div class="title-block">
						<div class="title-block__left">
							<div v-if="type == 'create'" class="title-block__title">
								Добавить новый документ
							</div>
							<div v-if="type == 'update'" class="title-block__title">
								Редактировать документ
							</div>
						</div>
					</div>
					
					<input type="hidden" id="documentIdInput" v-model="documentId">
										
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Название документа *</div>
							<input type="text" class="form-control" id="documentNameInput" placeholder="введите название" v-model="documentName">
						</div>
					</div>
										
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Описание документа</div>
							<textarea name="" id="documentDescriptionInput" cols="30" rows="3" class="form-control" placeholder="введите описание" v-model="documentDescription"></textarea>
						</div>
					</div>
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Url документа *</div>
							<input type="text" class="form-control" id="documentUrlInput" placeholder="введите название" v-model="documentUrl">
						</div>
					</div>
					
					<input type="hidden" id="documentClientInput" v-model="documentClientSelected">
					<div class="row mb-4">
						<div class="col-12">	
							<div class="form-label">Выберите клиента *</div>
							<v-select class="searchable" v-model="documentClient" 
								:options="clientOptions"
								@option:selected="onDocumentClientChange($event)"
								:deselectFromDropdown="false"
								:clearable="false">
								<template #no-options="{ search, searching, loading }">
									<div class="text-not-found">Не найдено</div>
								</template>
							</v-select>
						</div>	
					</div>
					
					<input type="hidden" id="documentSoftwareInput" v-model="documentSoftwareSelected">
					<div class="row mb-4">
						<div class="col-12">	
							<div class="form-label">Выберите программу *</div>
							<v-select class="searchable" v-model="documentSoftware"
								:options="softwareOptions"
								@option:selected="onDocumentSoftwareChange($event)"
								:deselectFromDropdown="false"
								:clearable="false">
								<template #no-options="{ search, searching, loading }">
									<div class="text-not-found">Не найдено</div>
								</template>
							</v-select>
						</div>	
					</div>
					
					<input type="hidden" id="documentVersionInput" v-model="documentVersionSelected">
					<div class="row mb-4">
						<div class="col-12">	
							<div class="form-label">Выберите версию *</div>
							<v-select class="searchable" v-model="documentVersion"
								:options="versionOptions"
								@option:selected="onDocumentVersionChange($event)"
								:deselectFromDropdown="false"
								:clearable="false">
								<template #no-options="{ search, searching, loading }">
									<div class="text-not-found">Не найдено</div>
								</template>
							</v-select>
						</div>	
					</div>
					
					<input type="hidden" id="documentTypeInput" v-model="documentTypeSelected">
					<div class="row mb-4">
						<div class="col-12">	
							<div class="form-label">Выберите тип документа *</div>
							<v-select class="searchable" v-model="documentType"
								:options="typeOptions"
								@option:selected="onDocumentTypeChange($event)"
								:deselectFromDropdown="false"
								:clearable="false">
								<template #no-options="{ search, searching, loading }">
									<div class="text-not-found">Не найдено</div>
								</template>
							</v-select>
						</div>	
					</div>
										
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Дата начала показа *</div>
							<input type="date" class="form-control" id="documentStartDateInput" placeholder="Placeholder" v-model="documentStartDate">
						</div>
					</div>					
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-label">Сортировка</div>
							<input type="text" class="form-control" id="documentSortInput" placeholder="введите название" v-model="documentSort">
						</div>
					</div>
					
					<div class="row mb-4">
						<div class="col-12">
							<div class="form-check">
								<input class="form-check-input" type="checkbox" value="" id="documentVisibleInput" v-model="documentVisible">
								<label class="form-check-label" for="documentVisibleInput"> Опубликован</label>
							</div>
						</div>
					</div>
					
					<div class="d-flex flex-column flex-lg-row justify-content-between">
						<button class="btn mb-2 mb-lg-0 me-lg-auto" @click.prevent="saveDocument">
							<span>Сохранить</span>
						</button>
						<button class="btn btn-lg btn-outline-dark" @click.prevent="cancel">
							<span>Отменить</span>
						</button>
					</div>
					
				</div>
				

			</div>
		</div>	
    </div>	
</template>

<script>

export default {
    name: "CreateDocumentDocumentationComponent",
	props: [
        'type',
        'element',
        'elementdetail',
		'clientlist',
		'softwarelist',
		'versionlist',
		'documenttypelist',
    ],
    
    data: () => {
        return {
            clientOptions: [],
            softwareOptions: [],
            versionOptions: [],
            typeOptions: [],
            documentClient: {label: ''},
            documentSoftware: {label: ''},
            documentVersion: {label: ''},
            documentType: {label: ''},
            documentId: '',
            documentName: '',
            documentUrl: '',
            documentSort: '',
            documentDescription: '',
            documentClientSelected: '',
            documentSoftwareSelected: '',
            documentVersionSelected: '',
            documentTypeSelected: '',
            documentSupportEndDate: '',
            documentStartDate: '',
            documentVisible: true,
        };
    },
	created() {

		if(this.clientlist.length > 0) {
			var list = [];
			this.clientlist.forEach(obj => {
				list.push({
					value: obj.id,
					label: obj.name,
				});
			});
			this.clientOptions = list;
		};
		
		if(this.softwarelist.length > 0) {
			var list = [];
			this.softwarelist.forEach(obj => {
				if(this.elementdetail.client_id) {
					if(obj.client == this.elementdetail.client_id) {	
						list.push({
							value: obj.id,
							label: obj.name
						});
					}
				} else {
					list.push({
						value: obj.id,
						label: obj.name
					});
				}
			});
			this.softwareOptions = list;
		};
		
		if(this.versionlist.length > 0) {
			var list = [];
			this.versionlist.forEach(obj => {
				if(this.elementdetail.sw_id) {
					if(obj.sw_id == this.elementdetail.sw_id) {	
						list.push({
							value: obj.id,
							label: obj.name
						});
					}
				} else {
					list.push({
						value: obj.id,
						label: obj.name
					});
				}
			});
			this.versionOptions = list;
		};
		
		if(this.documenttypelist.length > 0) {
			var list = [];
			this.documenttypelist.forEach(obj => {
				list.push({
					value: obj.id,
					label: obj.name,
				});
			});
			this.typeOptions = list;
		};
    },
    methods: {
        
		itemGet: async function () {
            this.documentId = this.elementdetail.id;
            this.documentName = this.elementdetail.name;
            this.documentUrl = this.elementdetail.url;
            this.documentDescription = this.elementdetail.description;
            this.documentSort = this.elementdetail.sort;
			this.documentClient = {value: this.elementdetail.client_id, label: this.elementdetail.client_name};
			this.documentClientSelected = this.elementdetail.client_id;
			this.documentSoftware = {value: this.elementdetail.sw_id, label: this.elementdetail.sw_name};
			this.documentSoftwareSelected = this.elementdetail.sw_id;
			this.documentVersion = {value: this.elementdetail.vers_id, label: this.elementdetail.vers_name};
			this.documentVersionSelected = this.elementdetail.vers_id;
			this.documentType = {value: this.elementdetail.type_id, label: this.elementdetail.type_name};
			this.documentTypeSelected = this.elementdetail.type_id;
			if(this.elementdetail.start_date) {
				var startDate = this.elementdetail.start_date.split(' ');
				this.documentStartDate = startDate[0];
			}
			this.documentVisible = (this.elementdetail.visible == 0) ? false : true;
        },

		cancel: function () {
			document.location = '/docs-edit';
		},
		
		saveDocument: function () {
			var documentData = {
				type: this.type,
				version: document.getElementById('documentVersionInput').value,
				url: document.getElementById('documentUrlInput').value,
				name: document.getElementById('documentNameInput').value,
				sort: document.getElementById('documentSortInput').value,
				doc_type: document.getElementById('documentTypeInput').value,
				description: document.getElementById('documentDescriptionInput').value,
				start_date: document.getElementById('documentStartDateInput').value,
				visible: document.getElementById('documentVisibleInput').checked ? 1 : 0,
			};
			if(this.type == 'update') {
				documentData.id = document.getElementById('documentIdInput').value;
			}
			axios.post('/docs-edit/document', documentData)
				.then(res => {
					if(res.data.status == 'error') {
						var error_list = '<h5>При добавлении версии произошли следующие ошибки:</h5><ul>';
						res.data.errors.forEach(error => {
							error_list += '<li>' + error + '</li>'
						});
						error_list += '</ul>';
						document.getElementById('response_errors').innerHTML = error_list;
						document.getElementById('response_errors').style.display = 'block';
						document.getElementById('response_errors').scrollIntoView({behavior: "smooth"});
					} else if(res.data.status == 'ok') {
						document.location = '/docs-edit';
					}
				});
		},
		
		onDocumentClientChange(events) {
			this.documentClientSelected = events.value;
			this.buildSoftwareOption();
			this.documentSoftwareSelected = '';
			this.documentVersionSelected = '';
		},
		
		onDocumentSoftwareChange(events) {
			this.documentSoftwareSelected = events.value;
			this.buildVersionOption();
			this.documentVersionSelected = '';
		},
		
		onDocumentVersionChange(events) {
			this.documentVersionSelected = events.value;
		},
		
		onDocumentTypeChange(events) {
			this.documentTypeSelected = events.value;
		},

		buildSoftwareOption: function () {
			var client = this.documentClientSelected;
			if(this.softwarelist.length > 0) {
				var list = [];
				this.softwarelist.forEach(obj => {
					if(obj.client == client) {	
						list.push({
							value: obj.id,
							label: obj.name
						});
					}	
				});
				this.softwareOptions = list;
				this.documentSoftware = {label: ''};
				this.documentVersion = {label: ''};
			}
		},
		
		buildVersionOption: function () {
			var software = this.documentSoftwareSelected;
			if(this.versionlist.length > 0) {
				var list = [];
				this.versionlist.forEach(obj => {
					if(obj.sw_id == software) {	
						list.push({
							value: obj.id,
							label: obj.name
						});
					}	
				});
				this.versionOptions = list;
				this.documentVersion = {label: ''};
			}
		},
		
    },
    mounted() {
		this.itemGet();
    },
};
</script>
